import React from "react";
import { Sun, Moon, Brain, BrainCircuit } from "lucide-react";

const Header = ({ theme = "light", onToggleTheme, isSidebarOpen, onToggleSidebar }) => {
  return (
    <header className={`flex items-center justify-between border-b px-6 py-3 ${
      theme === "dark"
        ? "border-slate-800 bg-slate-900"
        : "border-slate-200 bg-white"
    }`}>
      <div className="flex items-center gap-3">
        <button
          type="button"
          onClick={onToggleSidebar}
          className={`grid h-7 w-7 place-items-center rounded-lg bg-transparent p-0 leading-none transition ${
            theme === "dark"
              ? "text-white hover:bg-slate-800"
              : "text-[#333333] hover:bg-slate-100"
          }`}
          aria-label="Toggle sidebar"
        >
          {isSidebarOpen ? (
            <Brain size={20} stroke={theme === "dark" ? "#ffffff" : "#cc0452"} />
          ) : (
            <BrainCircuit size={20} stroke={theme === "dark" ? "#ffffff" : "#cc0452"} />
          )}
        </button>
      </div>
      <div className="flex items-center gap-3">
        <img
          src="/chat/InsightPro.svg"
          alt="InsightPro"
          className="h-10 w-auto object-contain"
        />
        <button
          type="button"
          onClick={onToggleTheme}
          className="flex items-center gap-2 rounded-xl bg-[#cc0452] px-3 py-2 text-xs font-medium text-white transition hover:brightness-110"
        >
          {theme === "dark" ? <Sun size={16} /> : <Moon size={16} />}
          {theme === "dark" ? "Light" : "Dark"}
        </button>
      </div>
    </header>
  );
};

export default Header;
